import { Col, Row } from "antd";
import React from "react";
import { useFormContext } from "react-hook-form";
import { useSelector } from "react-redux";
import { UsageType } from "../../../../../types/bookings";
import { InputField } from "../../../../atoms/FormElement";
import { getEmailValidationRules, getInputPlaceholderMessage, getValidationProps } from "../../../../libs/form";

type SignatoryFieldsProps = {
  usageType: UsageType;
};

export const SignatoryFields = (props: SignatoryFieldsProps) => {
  const { usageType } = props;

  const { control, setValue, formState } = useFormContext();
  const { errors } = formState;

  const defaultProps = { control, setValue };

  return (
    <>
      <Col span={24}>
        <p className="td-label">Signatory Information</p>
        <div className="ft-divider" />

        <Row gutter={24}>
          <Col span={8}>
            <InputField
              label="Email address"
              fieldname="signatoryUser.email"
              {...defaultProps}
              {...getValidationProps({
                fieldName: "signatoryUser.email",
                errors,
                isRequired: true,
                rules: getEmailValidationRules(),
              })}
              iProps={{ placeholder: getInputPlaceholderMessage("email address") }}
            />
          </Col>

          <Col span={8}>
            <InputField
              label="Signatory name"
              fieldname="signatoryUser.name"
              {...defaultProps}
              {...getValidationProps({
                fieldName: "signatoryUser.name",
                errors,
                isRequired: true,
              })}
              iProps={{ placeholder: getInputPlaceholderMessage("signatory name") }}
              r
            />
          </Col>

          {usageType === "residential" && (
            <Col span={8}>
              <InputField
                label="Signatory arabic name"
                fieldname="signatoryUser.arabicName"
                {...defaultProps}
                {...getValidationProps({ fieldName: "signatoryUser.arabicName", errors, isRequired: true })}
                iProps={{ placeholder: "جون سميث" }}
              />
            </Col>
          )}
        </Row>

        <Row gutter={24}>
          <Col span={8}>
            <InputField
              label="Mobile number"
              fieldname="signatoryUser.mobile"
              {...defaultProps}
              {...getValidationProps({
                fieldName: "signatoryUser.mobile",
                errors,
                isRequired: true,
                rules: {
                  minLength: { value: 8, message: "Please enter valid mobile number, 8 digits required" },
                  maxLength: { value: 9, message: "Please enter valid mobile number, 9 digits required" },
                },
              })}
              iProps={{ addonBefore: "+971", placeholder: "123456789" }}
            />
          </Col>

          <Col span={8}>
            <InputField
              label="Designation"
              fieldname="signatoryUser.designation"
              {...defaultProps}
              {...getValidationProps({ fieldName: "signatoryUser.designation", errors, isRequired: true })}
              iProps={{ placeholder: getInputPlaceholderMessage("designation") }}
            />
          </Col>

          <Col span={8}>
            <InputField
              label="Company"
              fieldname="signatoryUser.company"
              {...defaultProps}
              {...getValidationProps({ fieldName: "signatoryUser.company", errors, isRequired: true })}
              iProps={{ placeholder: getInputPlaceholderMessage("company") }}
            />
          </Col>
        </Row>
      </Col>
    </>
  );
};
